// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.answers-list {
  display: flex;
  padding: 0 20px;
  flex-direction: column;
  height: 100%;
}
.answers-list .c-icon-button {
  margin-right: 10px;
  margin-top: -5px;
}
.answers-list .existing-question {
  flex: 1;
  max-width: calc(100% - 44px);
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
  height: 50px;
}
.answers-list__selected-question {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.answers-list__selected-question button {
  min-width: 44px;
}
.answers-list__selected-question svg {
  transform: rotate(90deg);
}
.answers-list__list {
  padding: 0 10px 40px 10px;
  overflow-y: auto;
  flex: 0 1 auto;
}
.answers-list__item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.answers-list__item:last-of-type {
  margin-bottom: 0;
}
.answers-list__item .c-svg-icon {
  margin-right: 7px;
  width: 19px;
  min-width: 19px;
  height: 19px;
  color: white;
  border-radius: 50%;
  background-color: #a0a0a0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.answers-list__item .c-svg-icon svg {
  height: 12px;
}
.answers-list__not-available {
  padding: 30px 0;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/configure-modals/configure-from-existing-questions/existing-questions/answers-list/answers-list.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;AADF;AAGE;EACE,kBAAA;EACA,gBAAA;AADJ;AAIE;EACE,OAAA;EACA,4BAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAHJ;AAKI;EACE,eAAA;AAHN;AAMI;EACE,wBAAA;AAJN;AAQE;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAPJ;AASI;EACE,gBAAA;AAPN;AAUI;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARN;AAUM;EACE,YAAA;AARR;AAaE;EACE,eAAA;EACA,kBAAA;AAXJ","sourcesContent":["@import '../../../../../styles/variables';\n\n.answers-list {\n  display: flex;\n  padding: 0 20px;\n  flex-direction: column;\n  height: 100%;\n\n  .c-icon-button {\n    margin-right: 10px;\n    margin-top: -5px;\n  }\n\n  .existing-question {\n    flex: 1;\n    max-width: calc(100% - 44px);\n    align-items: center;\n    padding-top: 0;\n    padding-bottom: 0;\n    height: 50px;\n  }\n\n  &__selected-question {\n    display: flex;\n    margin-bottom: 20px;\n    align-items: center;\n\n    button {\n      min-width: 44px;\n    }\n\n    svg {\n      transform: rotate(90deg);\n    }\n  }\n\n  &__list {\n    padding: 0 10px 40px 10px;\n    overflow-y: auto;\n    flex: 0 1 auto;\n  }\n\n  &__item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n\n    .c-svg-icon {\n      margin-right: 7px;\n      width: 19px;\n      min-width: 19px;\n      height: 19px;\n      color: white;\n      border-radius: 50%;\n      background-color: #a0a0a0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      svg {\n        height: 12px;\n      }\n    }\n  }\n\n  &__not-available {\n    padding: 30px 0;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
